import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { InputNumber, Select } from 'antd';
import { clearSearchFilters as clear } from '../../../../actions';
import FilterWrapper from '../../FilterWrapper';
import { t } from '../../../../helpers/t';

const { Option } = Select;

const DAYS_IN_A_MONTH = 28;
const DAYS_IN_A_WEEK = 7;
const DAYS_IN_A_DAY = 1;

const DURATIONS = [
  { label: 'monthly_price', value: DAYS_IN_A_MONTH },
  { label: 'weekly_price', value: DAYS_IN_A_WEEK },
  { label: 'daily_price', value: DAYS_IN_A_DAY },
];

const DEFAULT_FILTER_VALUE = DURATIONS[0].value;

const DurationSelector = ({ label, value }) => (
  <Option key={value} value={value}>
    {t(`directives.forms.formRows.timeUnitImput.${label}`)}
  </Option>
);

const Duration = ({ updateSearchFilters }) => {
  const dispatch = useDispatch();
  const durationDays = useSelector((state) => state.searchFilters.parameters.duration);
  const durationMatchesDays = (duration) => Number.isInteger(durationDays / duration.value);
  const correspondingDuration = find(DURATIONS, durationMatchesDays) || DURATIONS[0];

  const [inputValue, setInputValue] = useState(null);
  const [selectedTimeGrain, setSelectedTimeGrain] = useState(DEFAULT_FILTER_VALUE);

  useEffect(() => {
    const valueFromStore = durationDays ? (durationDays / correspondingDuration.value) : null;
    setInputValue(valueFromStore);
    setSelectedTimeGrain(correspondingDuration.value);
  }, [durationDays, correspondingDuration.value]);

  return (
    <FilterWrapper>
      <div className="duration-filter-inputs">
        <InputNumber
          className="duration-number-input"
          onChange={(value) => {
            if (value === 0) {
              if (inputValue) {
                dispatch(clear(['duration']));
              }

              setInputValue(null);
            } else {
              setInputValue(value);
              updateSearchFilters({ duration: selectedTimeGrain * value });
            }
          }}
          min={0}
          size="large"
          value={inputValue}
          placeholder={t('directives.listings.listingFilters.duration.placeholder')}
        />
        <Select
          className="duration-selector"
          size="large"
          value={selectedTimeGrain}
          dropdownMatchSelectWidth
          onChange={(option) => {
            setSelectedTimeGrain(option);

            if (inputValue) {
              updateSearchFilters({ duration: option * inputValue });
            }
          }}
        >
          {DURATIONS.map(DurationSelector)}
        </Select>
      </div>
    </FilterWrapper>
  );
};

Duration.propTypes = {
  updateSearchFilters: PropTypes.func.isRequired,
};

DurationSelector.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default Duration;
